<template>
  <Layout
    :clientId="clientId"
    :showid="0"
    :ads="ads"
    :channels="channels"
    :setTitle="title"
    :apiOrigin="apiOrigin"
  >
    <!-- {{ newsBig }} -->
    <!-- {{ newsLunbo }} -->
    <!-- {{ newsSmall }} -->
    <div>
      <div class="backgroud1">
        <div class="backgroud2">
          <section class="headline" v-if="newsBig && newsBig.length > 0">
            <div class="outer clear">
              <div class="lf">
                <div>
                  关<br />
                  注
                </div>
              </div>
              <div class="news">
                <div
                  class="bold"
                  style="font-size: 40px;"
                  v-show="newsBig.length > 0"
                >
                  <a
                    v-for="(item, index) in newsBig"
                    :key="index"
                    :type="item.id"
                    @click="clickAction(item)"
                    target="_blank"
                    >{{ item.title }}</a
                  >
                </div>
                <div v-if="newsSmall.length > 3">
                  <a
                    v-for="(item, index) in newsSmall"
                    :key="index"
                    :type="item.id"
                    @click="clickAction(item)"
                    target="_blank"
                    >{{ item.title }}</a
                  >
                </div>
                <div v-else>
                  <a
                    v-for="(item, index) in newsSmall"
                    :key="index"
                    :type="item.id"
                    @click="clickAction(item)"
                    target="_blank"
                    >{{ item.title }}</a
                  >
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <section
        class="outer news_scroll"
        style="padding-top:22px;padding-bottom: 0"
      >
        <div class="news_scroll" v-if="newsLunbo && newsLunbo.length > 0">
          <div class="clear">
            <div class="scroll">
              <div class="lf">滚 动</div>
              <div class="rt">
                <div class="scroll_container">
                  <div class="box">
                    <div class="s1">
                      <a
                        v-for="(item, index) in newsLunbo"
                        :key="index"
                        :type="item.id"
                        @click="clickAction(item)"
                        target="_blank"
                        >{{ item.title }}</a
                      >
                    </div>
                    <div class="s2">
                      <a
                        v-for="(item, index) in newsLunbo"
                        :key="index"
                        :type="item.id"
                        @click="clickAction(item)"
                        target="_blank"
                        >{{ item.title }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="article">
        <swiper
          v-if="ads.slide.items"
          :list="ads.slide.items"
          type="1"
        ></swiper>
        <publicList :list="newsList" :clientId="clientId"></publicList>
        <a
          class="more"
          @click="more"
          :disabled="showMore == '加载中'"
          v-show="meta.page_count > meta.current_page"
          href="javascript:;"
          id="pc-more"
          >{{ showMore }}</a
        >
        <a
          class="more"
          v-show="newsList.length == 0 || meta.page_count == meta.current_page"
          href="javascript:;"
          id="pc-more"
          >没有更多了</a
        >
      </div>
      <div class="aside aside-bside">
        <div class="aside aside-bside">
          <rankingAside
            v-if="clientId == 321300"
            :list="reWenList"
            title="排行榜"
          ></rankingAside>
          <newsAside v-else :list="reWenList" title="热文"></newsAside>
          <news-aside
            v-if="clientId !== 410600"
            :list="bianMinList"
            title="便民"
          ></news-aside>
        </div>
        <adAside :list="ads.slideBars" :clientId="clientId"></adAside>
        <a v-if="clientId == 321300" href="https://www.12377.cn" target="_blank"
          ><img
            style="width:320px;height:95px;display:block;margin:0 auto"
            src="/public/w/img/321300/jubao.jpg"
        /></a>
      </div>
    </div>
  </Layout>
</template>
<style lang="css">
@import "~asset/news-pc/css/css.css";

body {
  margin: 0 0px;
}

a {
  text-decoration: none;
}
</style>
<script>
import Layout from "component/web/news-layout";
import newsAside from "component/web/news-aside/index";
import adAside from "component/web/news-aside/ad-aside";
import rankingAside from "component/web/news-aside/ranking-aside";
import swiper from "component/web/swiper/swiper";
import publicList from "component/web/news-list/public-list";
import axios from "asset/news-pc/js/axios.js";
import api from "asset/news-pc/js/api.js";
import { parse } from "date-fns";
export default {
  components: {
    Layout,
    newsAside,
    publicList,
    swiper,
    adAside,
    rankingAside,
  },
  data() {
    return {
      showid: 0,
      page: 1,
      showMore: "加载更多",
      // pageList: [],
      /*                 newsList: [],
                                bianMinList: [],
                                reWenList: [], */
    };
  },
  mounted() {
    /*             axios.get(api.news).then(data => {
                            this.newsList = data.data.data.items;
                            this.pageList = data.data.data.items;
                        });
                        axios.get(api.rewen).then(data => {
                            this.reWenList = data.data.data.items;
                        });
                        axios.get(api.bianmin).then(data => {
                            this.bianMinList = data.data.data.items;
                        }); */
    // 解决广告图片懒加载不起作用

    document.documentElement.scrollTop = document.documentElement.scrollTop + 1;

    var speed = 20;
    var tab = document.querySelector(".news_scroll .scroll_container");
    var tab1 = document.querySelector(".news_scroll .s1");
    var tab2 = document.querySelector(".news_scroll .s2");
    tab2.innerHTML = tab1.innerHTML;
    function Marquee() {
      if (tab2.offsetWidth - tab.scrollLeft <= 0) {
        tab.scrollLeft -= tab1.offsetWidth;
      } else {
        tab.scrollLeft++;
      }
    }

    clearInterval(MyMar);
    var MyMar = setInterval(Marquee, speed);
    tab.onmouseover = function() {
      clearInterval(MyMar);
    };
    tab.onmouseout = function() {
      MyMar = setInterval(Marquee, speed);
    };
  },
  methods: {
    more() {
      this.page++;
      this.showMore = "加载中";
      axios.get(`${api.news}?page=${this.page}&recommended=1`).then((data) => {
        this.newsList = [...this.newsList, ...data.data.data.items];
        this.pageList = data.data.data.items;
        this.meta = data.data.data._meta;
        this.showMore = "加载更多";
      });
    },
    clickAction(item) {
      console.log(item);
      if (item.third_url != "") {
        window.open(item.third_url);
      } else {
        window.open(`${location.origin}/news/${item.id}`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/web/page/news-pc/index.vue